export const SCORECARD_ERROR_MESSAGE = "Something went wrong. Please try again.";
